// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/compass-construction.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/compass-construction/compass-construction.js';

mount([g0]);
